import React, {useEffect} from 'react';

// Components
import Breadcrumb from "./Breadcrumb";
import {staggeredFadeInDivEffect} from "./staggeredFadeInDivEffect";
import {BackToTop} from "./BackToTop";

// CSS
import '../style/css/components/Competencias.css';
import '../style/css/components/Card.css';

function Competencias(){

	const skills = [
		{
			'name': 'Front-End',
			'level': 'Pleno',
			'projects': '+50',
			'skills': [
				{
					'name': 'HTML5',
					'icon': 'lab la-html5',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Senior',
					'years': '10',
				},
				{
					'name': 'CSS3',
					'icon': 'lab la-css3-alt',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Senior',
					'years': '10',
				},
				{
					'name': 'Sass CSS',
					'icon': 'lab la-less',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Senior',
					'years': '7',
				},
				{
					'name': 'JavaScript',
					'icon': 'lab la-js-square',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '10',
				},
				{
					'name': 'jQuery',
					'icon': 'lab la-js-square',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '7',
				},
				{
					'name': 'WordPress',
					'icon': 'lab la-wordpress',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '4',
				},
				{
					'name': 'React',
					'icon': 'lab la-react',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '5',
				},
				{
					'name': 'Next.js',
					'icon': 'lab la-react',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '5',
				}
			]
		},
		{
			'name': 'Back-End',
			'level': 'Pleno',
			'projects': '+20',
			'skills': [
				{
					'name': 'PHP',
					'icon': 'lab la-php',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '8',
				},
				{
					'name': 'Laravel',
					'icon': 'lab la-laravel',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '5',
				},
				{
					'name': 'MySQL',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '8',
				},
				{
					'name': 'SQL Server',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '3',
				},
				{
					'name': "API RESTful",
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '6',
				},
				{
					'name': 'Design Patterns',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '4',
				}
			]
		},
		{
			'name': 'DevOps',
			'level': 'Junior',
			'projects': '2',
			'skills': [
				{
					'name': 'Linux Ubuntu',
					'icon': 'lab la-ubuntu',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '5',
				},
				{
					'name': 'Windows WSL',
					'icon': 'lab la-windows',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '4',
				},
				{
					'name': 'Nginx',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '4',
				},
				{
					'name': 'Supervisor (Process Control System)',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '4',
				},
			]
		},
		{
			'name': 'Outros',
			'level': 'conhecimentos',
			'skills': [
				{
					'name': 'Git & Git Workflow',
					'icon': 'lab la-git',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '7',
				},
				{
					'name': 'Scrum & Kanban',
					'icon': 'lab la-trello',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Pleno',
					'years': '8',
				},
				{
					'name': 'Tech Lead',
					'icon': '',
					'info': 'lorem ipsum dolor sit amet',
					'level': 'Junior',
					'years': '3',
				},
			]
		},
	];

	useEffect(()=>{
		BackToTop();
		staggeredFadeInDivEffect(20)
	})

	return (
		<div className='fade-enter'>
			<Breadcrumb page='Competências'/>

			<h1>Competências</h1>

			<div className="row">

				{
					skills.map(function(stack, stack_index){
						return (
							<div className='col' key={stack_index}>
								<div className="card card-stack fade-enter">
									<div className="row">
										<div className="col fade-enter">
											<h3 className='fade-enter'>{stack.name}</h3>
											<p className='fade-enter'><strong>{stack.level}</strong></p>
											<hr/>
										</div>
									</div>
									<div className="row">
										<div className="col">
											<ul>
												{
													stack.skills.map(function(skill, skill_index){

														return (
															<li key={skill_index}>
																<div
																	className='card card-skill fade-enter'
																>
																	<h5 className='fade-enter'><i className={skill.icon}/> {skill.name}</h5>
																	<div className="fade-enter">
																		<p><strong>Nível:</strong> {skill.level}</p>
																		<p><strong>Experiência:</strong> {skill.years} ano(s)</p>
																	</div>
																</div>
															</li>
														);

													})
												}
											</ul>
										</div>
									</div>
								</div>
							</div>
						);
					})
				}

			</div>

		</div>
	);
}

export default Competencias;
